module.exports = __webpack_public_path__ + "img/pencil-line.62117cd2.svg";